var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper',_vm._g(_vm._b({staticClass:"omapi-has-tooltip",class:_vm.conditionalClasses,attrs:{"trigger":_vm.trigger,"force-show":_vm.forceShow,"tag-name":_vm.tagName,"disabled":_vm.disabled,"options":{
		placement: _vm.placement,
		modifiers: {
			flip: {
				enabled: false,
			},
			preventOverflow: {
				escapeWithReference: true,
			},
		},
	},"delay-on-mouse-over":_vm.delay}},'popper',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"popper"},[(_vm.tooltip)?_c('span',[_vm._v(_vm._s(_vm.tooltip))]):_vm._e(),_vm._t("tooltip")],2),_vm._t("default",function(){return [(_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component"}):_vm._e()]},{"slot":"reference"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }